import { render, staticRenderFns } from "./NewFanFollowList.vue?vue&type=template&id=05ecf791&scoped=true"
import script from "./NewFanFollowList.vue?vue&type=script&lang=js"
export * from "./NewFanFollowList.vue?vue&type=script&lang=js"
import style0 from "./NewFanFollowList.vue?vue&type=style&index=0&id=05ecf791&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ecf791",
  null
  
)

export default component.exports